module.exports = __webpack_public_path__ + "static/media/trash-undo.c3bfccaf.svg";